import React, { useState, useContext } from 'react';
import classnames from 'classnames';

import Context from "../context/context";

import Checkboxes from './Checkboxes';
import Search from './Search';


const Widget = props => {
  const {filterNav, setFilterNav, language, setNavStatus } = useContext(Context);
  const {widget, clearAllFilters, viewResults, toggleFilterNav} = props;


  return (
    <>
    <div
      className={classnames('form-section filter-section level-2', {
        open: widget.open
      })}
    >

    <div className="level-2-nav">
      <button
        className="close-filters"
        onClick={() => toggleFilterNav(widget)}
      >Back to all filters</button>
      <div className="widget-title font-title font-lead">Browse By {widget.title}:</div>

      {
        (widget.position != "top" && widget.type != "hidden") &&
          widget.filters.map((filter, i) => {
            switch(filter.type){
              case "checkbox":
                return <Checkboxes single={true} key={i} widget={widget} data={filter} title={widget.title} clearAllFilters={clearAllFilters} multi={widget.filters.length > 1}  viewResults={viewResults}  />
                break;

              case "search":
                return <Search single={true} key={i} widget={widget} data={filter} title={widget.title} clearAllFilters={clearAllFilters} multi={widget.filters.length > 1}  viewResults={viewResults}  />
                break;

              default:
                <div>Error</div>
            }
          })

      }
    </div>




    </div>


    </>
  )
}

export default Widget;
